const initialState = {
  userPackages: [],
  selectedPackage: null,
  selectedPackageForm: null,
  pagination: {
    package: {
      packageLimit: 5,
      packagePage: 1,
      totalPackageRecord: 0,
    },
    form: {
      formLimit: 5,
      formPage: {}, // Tracks document pages per package (dynamic per packageID)
      totalFormRecord: {},
    },
  },
  signatures: [],
  customCreateNoc: {},
  errorMarkedFile: "",
};

const userPackagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_CUSTOM_CREATE_NOC_CONTRACTOR":
      return {
        ...state,
        customCreateNoc: {
          ...state.customCreateNoc,
          contractor: {
            ...state.customCreateNoc.contractor,
            ...action.payload,
            PERSON: {
              ...state.customCreateNoc.contractor?.PERSON,
              ...action.payload.PERSON,
            },
            ORGANIZATION: {
              ...state.customCreateNoc.contractor?.ORGANIZATION,
              ...action.payload.ORGANIZATION,
            },
          },
        },
      };
    case "UPDATE_CUSTOM_CREATE_NOC":
      return {
        ...state,
        customCreateNoc: {
          ...state.customCreateNoc,
          [action.payload.type]: {
            ...state.customCreateNoc[action.payload.type],
            ...(action.payload.nested
              ? {
                  [action.payload.nested]: {
                    ...state.customCreateNoc[action.payload.type]?.[
                      action.payload.nested
                    ],
                    [action.payload.key]: action.payload.value,
                  },
                }
              : { [action.payload.key]: action.payload.value }),
          },
        },
      };
    case "UPDATE_CUSTOM_CREATE_NOC_PROJECT_ADDRESS":
      return {
        ...state,
        customCreateNoc: {
          ...state.customCreateNoc,
          document_location: {
            ...state.customCreateNoc.document_location,
            project_address: action.payload,
          },
        },
      };
    case "UPDATE_CUSTOM_CREATE_NOC_COUNTY":
      return {
        ...state,
        customCreateNoc: {
          ...state.customCreateNoc,
          document_location: {
            ...state.customCreateNoc.document_location,
            county: action.payload,
          },
        },
      };
    case "CLEAR_CUSTOM_CREATE_NOC":
      return {
        ...state,
        customCreateNoc: {},
        errorMarkedFile: "",
      };
    case "UPDATE_ERROR_MARKED_FILE":
      return {
        ...state,
        errorMarkedFile: action.payload,
      };
    case "UPDATE_SELECTED_PACKAGE": {
      const selected = state.userPackages.find(
        (pkg) => pkg.packageID === action.payload
      );
      return {
        ...state,
        selectedPackage: selected || null,
        selectedPackageForm: selected?.documents?.[0] || null,
      };
    }
    case "DISCARD_CUSTOM_DOCUMENTS_NOC":
      return {
        ...state,
        customCreateNoc: {},
      };

    case "UPDATE_CUSTOM_DOCUMENTS_NOC":
      return {
        ...state,
        customCreateNoc: action.payload,
      };

    case "UPDATE_PACKAGE_AND_SELECT":
      return {
        ...state,
        userPackages: state.userPackages.map((pkg) =>
          pkg.packageID === action.payload.packageID ? action.payload : pkg
        ),
        selectedPackage: action.payload,
      };

    case "UPDATE_SELECTED_PACKAGE_OBJECT":
      return {
        ...state,
        selectedPackage: action.payload || null,
      };

    case "UPDATE_SELECTED_PACKAGE_FORM_OBJECT":
      return {
        ...state,
        selectedPackageForm: action.payload || null,
      };

    case "UPDATE_SELECTED_PACKAGE_WITH_FORM": {
      const selected = state.userPackages.find(
        (pkg) => pkg.packageID === action.payload.packageID
      );
      const selectedForm = selected?.documents?.find(
        (doc) => doc.formID === action.payload.formID
      );
      return {
        ...state,
        selectedPackage: selected || null,
        selectedPackageForm: selectedForm || null,
      };
    }

    case "ADD_NEW_USER_PACKAGE":
      return {
        ...state,
        userPackages: [...state.userPackages, action.payload],
      };

    case "ADD_CUSTOM_DOCUMENTS_NOC":
      return {
        ...state,
        customCreateNoc: action.payload,
      };

    case "ADD_USER_PACKAGES":
      return {
        ...state,
        userPackages: [...state.userPackages, ...action.payload.newPackages], // ✅ Append new packages
        pagination: {
          ...state.pagination,
          package: {
            ...state.pagination.package,
            packagePage: action.payload.packagePage, // ✅ Update pagination page
            totalPackageRecord: action.payload.totalPackageRecord, // ✅ Store total packages
          },
        },
      };

    case "ADD_DOCUMENTS_TO_PACKAGE":
      return {
        ...state,
        userPackages: state.userPackages.map((packageItem) =>
          packageItem.packageID === action.payload.packageID
            ? {
                ...packageItem,
                documents: [
                  ...packageItem.documents,
                  ...action.payload.documents,
                ], // ✅ Append new documents
              }
            : packageItem
        ),
        pagination: {
          ...state.pagination,
          form: {
            ...state.pagination.form,
            formPage: {
              ...state.pagination.form.formPage,
              [action.payload.packageID]: action.payload.formPage, // ✅ Track document page per package
            },
            totalFormRecord: {
              ...state.pagination.form.totalFormRecord,
              [action.payload.packageID]: action.payload.totalFormRecord, // ✅ Track total docs per package
            },
          },
        },
      };
    case "ADD_BASE64_TO_PACKAGE":
      return {
        ...state,
        userPackages: state.userPackages.map((packageItem) =>
          packageItem.packageID === action.payload.packageID
            ? {
                ...packageItem,
                documents: packageItem.documents.map((document) =>
                  document.formID === action.payload.formID
                    ? {
                        ...document,
                        tempFields: {
                          ...document.tempFields,
                          formFields: action.payload.formFields,
                          currentDocument: {
                            ...document.tempFields.currentDocument,
                            base64File: action.payload.BASE64,
                          },
                        },
                      }
                    : document
                ),
              }
            : packageItem
        ),
      };

    case "UPDATE_TEMP_FIELDS":
      return {
        ...state,
        userPackages: state.userPackages.map((packageItem) =>
          packageItem.packageID === action.payload.packageID
            ? {
                ...packageItem,
                documents: packageItem.documents.map((document) =>
                  document.formID === action.payload.formID
                    ? {
                        ...document,
                        tempFields: {
                          ...document.tempFields,
                          formFields: action.payload.formFields,
                        },
                      }
                    : document
                ),
              }
            : packageItem
        ),
        selectedPackage:
          state.selectedPackage?.packageID === action.payload.packageID
            ? {
                ...state.selectedPackage,
                documents: state.selectedPackage.documents.map((document) =>
                  document.formID === action.payload.formID
                    ? {
                        ...document,
                        tempFields: {
                          ...document.tempFields,
                          formFields: action.payload.formFields,
                        },
                      }
                    : document
                ),
              }
            : state.selectedPackage,

        selectedPackageForm:
          state.selectedPackageForm?.formID === action.payload.formID
            ? {
                ...state.selectedPackageForm,
                tempFields: {
                  ...state.selectedPackageForm.tempFields,
                  formFields: action.payload.formFields,
                },
              }
            : state.selectedPackageForm,
      };

    case "UPDATE_EDITING_FORM":
      const { document, ...packageBase } = action.payload;

      if (
        !Array.isArray(state.userPackages) ||
        state.userPackages.length === 0
      ) {
        console.warn(
          "⚠️ [UPDATE_EDITING_FORM] No userPackages found! Returning state."
        );
        return state;
      }

      const updatedPackages = state.userPackages.map((packageItem) => {
        if (packageItem.packageID === packageBase.packageID) {
          const updatedDocuments = packageItem.documents.map((doc) => {
            if (doc.formID === document.formID) {
              return {
                ...doc,
                tempFields: {
                  ...doc.tempFields, // Keep existing fields
                  ...document.tempFields, // ✅ Merge latest tempFields
                  currentDocument: {
                    ...doc.tempFields.currentDocument, // Keep previous values
                    ...document.tempFields.currentDocument, // ✅ Merge new currentDocument updates
                  },
                },
              };
            }
            return doc;
          });

          return {
            ...packageItem,
            ...packageBase,
            documents: updatedDocuments, // ✅ Replace only updated documents
          };
        }
        return packageItem;
      });

      return {
        ...state,
        userPackages: updatedPackages,
      };

    case "REMOVE_FIXED_FIELDS": {
      const { packageID, formID, prefix } = action.payload;

      if (
        !Array.isArray(state.userPackages) ||
        state.userPackages.length === 0
      ) {
        console.warn(
          "⚠️ [REMOVE_FIXED_FIELDS] No userPackages found! Returning state."
        );
        return state;
      }

      const updatedPackages = state.userPackages.map((packageItem) => {
        if (packageItem.packageID === packageID) {
          const updatedDocuments = packageItem.documents.map((doc) => {
            if (doc.formID === formID) {
              return {
                ...doc,
                tempFields: {
                  ...doc.tempFields,
                  formFields: doc.tempFields.formFields?.filter(
                    (field) => !field.name?.startsWith(prefix)
                  ),
                },
              };
            }
            return doc;
          });

          return {
            ...packageItem,
            documents: updatedDocuments,
          };
        }
        return packageItem;
      });

      return {
        ...state,
        userPackages: updatedPackages,
      };
    }

    case "TOGGLE_IM_SIGNER":
      return {
        ...state,
        userPackages: state.userPackages.map((pkg) => {
          if (pkg.packageID !== action.payload.packageID) return pkg;

          const updatedSigners = {};
          for (const key in pkg.signers) {
            updatedSigners[key] = {
              ...pkg.signers[key],
              im_sign:
                action.payload.signerKey === key &&
                action.payload.signerKey !== null,
              ...(action.payload.signerKey === key &&
              action.payload.signerKey !== null
                ? action.payload.signerFields
                : {}),
            };
          }

          return {
            ...pkg,
            signers: updatedSigners,
          };
        }),

        selectedPackage:
          state.selectedPackage?.packageID === action.payload.packageID
            ? {
                ...state.selectedPackage,
                signers: Object.fromEntries(
                  Object.entries(state.selectedPackage.signers).map(
                    ([key, val]) => [
                      key,
                      {
                        ...val,
                        im_sign:
                          action.payload.signerKey === key &&
                          action.payload.signerKey !== null,
                        ...(action.payload.signerKey === key &&
                        action.payload.signerKey !== null
                          ? action.payload.signerFields
                          : {}),
                      },
                    ]
                  )
                ),
              }
            : state.selectedPackage,
      };

    case "EMPTY_SIGNER":
      const emptyFields = {
        first_name: "",
        middle_name: "",
        last_name: "",
        company_name: "",
        email: "",
        phone_number: "",
        address: "",
        im_sign: false,
      };

      return {
        ...state,
        userPackages: state.userPackages.map((pkg) => {
          if (pkg.packageID !== action.payload.packageID) return pkg;

          return {
            ...pkg,
            signers: {
              ...pkg.signers,
              [action.payload.signerKey]: {
                ...pkg.signers?.[action.payload.signerKey],
                ...emptyFields,
              },
            },
          };
        }),
        selectedPackage:
          state.selectedPackage?.packageID === action.payload.packageID
            ? {
                ...state.selectedPackage,
                signers: {
                  ...state.selectedPackage.signers,
                  [action.payload.signerKey]: {
                    ...state.selectedPackage.signers?.[
                      action.payload.signerKey
                    ],
                    ...emptyFields,
                  },
                },
              }
            : state.selectedPackage,
      };

    case "UPDATE_SIGNER_FIELD":
      return {
        ...state,
        userPackages: state.userPackages.map((pkg) => {
          if (pkg.packageID !== action.payload.packageID) return pkg;

          const prevSignerData = pkg.signers?.[action.payload.signerKey] || {};
          const updatedSigners = {
            ...pkg.signers,
            [action.payload.signerKey]: {
              ...prevSignerData,
              [action.payload.field]: action.payload.value,
            },
          };

          return {
            ...pkg,
            signers: updatedSigners,
          };
        }),

        selectedPackage:
          state.selectedPackage?.packageID === action.payload.packageID
            ? {
                ...state.selectedPackage,
                signers: {
                  ...state.selectedPackage.signers,
                  [action.payload.signerKey]: {
                    ...state.selectedPackage.signers?.[
                      action.payload.signerKey
                    ],
                    [action.payload.field]: action.payload.value,
                  },
                },
              }
            : state.selectedPackage,
      };

    case "UPDATE_PROCESS_OPTIONS":
      return {
        ...state,
        userPackages: state.userPackages.map((pkg) =>
          pkg.packageID === action.payload.packageID
            ? {
                ...pkg,
                documents: pkg.documents.map((doc) =>
                  doc.formID === action.payload.formID
                    ? {
                        ...doc,
                        actions: {
                          ...doc.actions,
                          [action.payload.options.name]:
                            action.payload.options.checked,
                        },
                      }
                    : doc
                ),
              }
            : pkg
        ),
        selectedPackage:
          state.selectedPackage?.packageID === action.payload.packageID
            ? {
                ...state.selectedPackage,
                documents: state.selectedPackage.documents.map((doc) =>
                  doc.formID === action.payload.formID
                    ? {
                        ...doc,
                        actions: {
                          ...doc.actions,
                          [action.payload.options.name]:
                            action.payload.options.checked,
                        },
                      }
                    : doc
                ),
              }
            : state.selectedPackage,

        selectedPackageForm:
          state.selectedPackageForm?.formID === action.payload.formID
            ? {
                ...state.selectedPackageForm,
                actions: {
                  ...state.selectedPackageForm.actions,
                  [action.payload.options.name]: action.payload.options.checked,
                },
              }
            : state.selectedPackageForm,
      };

    case "UPDATE_PACKAGE_NAME":
      return {
        ...state,
        userPackages: state.userPackages.map((packageItem) =>
          packageItem.packageID === action.payload.packageID
            ? { ...packageItem, packageName: action.payload.value }
            : packageItem
        ),
      };
    case "UPDATE_DOC_NAME":
      return {
        ...state,
        userPackages: state.userPackages.map((packageItem) =>
          packageItem.packageID === action.payload.packageID
            ? {
                ...packageItem,
                documents: packageItem.documents.map((doc) =>
                  doc.formID === action.payload.docID
                    ? { ...doc, document_name: action.payload.value }
                    : doc
                ),
              }
            : packageItem
        ),
      };
    case "UPDATE_DOC_FILENAME":
      return {
        ...state,
        userPackages: state.userPackages.map((packageItem) =>
          packageItem.packageID === action.payload.packageID
            ? {
                ...packageItem,
                documents: packageItem.documents.map((doc) =>
                  doc.formID === action.payload.docID
                    ? { ...doc, cleaned_file_name: action.payload.value }
                    : doc
                ),
              }
            : packageItem
        ),
      };
    case "DELETE_USER_PACKAGE_DOCUMENT":
      const updatedUserPackages = state.userPackages.map((packageItem) =>
        packageItem.packageID === action.payload.packageID
          ? {
              ...packageItem,
              documents: packageItem.documents.filter(
                (doc) => doc.formID !== action.payload.docID
              ),
            }
          : packageItem
      );

      return {
        ...state,
        userPackages: updatedUserPackages,
      };
    case "DELETE_USER_PACKAGE":
      return {
        ...state,
        userPackages: state.userPackages.filter(
          (packageItem) => packageItem.packageID !== action.payload.packageID
        ),
        selectedPackage:
          state.selectedPackage?.packageID === action.payload.packageID
            ? null
            : state.selectedPackage,
        selectedPackageForm:
          state.selectedPackageForm &&
          state.selectedPackageForm.packageID === action.payload.packageID
            ? null
            : state.selectedPackageForm,
      };

    case "TOGGLE_DOCUMENT_LOCK":
      return {
        ...state,
        userPackages: state.userPackages.map((packageItem) =>
          packageItem.packageID === action.payload.packageID
            ? {
                ...packageItem,
                documents: packageItem.documents.map((doc) =>
                  doc.formID === action.payload.docID
                    ? {
                        ...doc,
                        locked: action.payload.locked,
                      }
                    : doc
                ),
              }
            : packageItem
        ),
        selectedPackage:
          state.selectedPackage?.packageID === action.payload.packageID
            ? {
                ...state.selectedPackage,
                documents: state.selectedPackage.documents.map((doc) =>
                  doc.formID === action.payload.docID
                    ? {
                        ...doc,
                        locked: action.payload.locked,
                      }
                    : doc
                ),
              }
            : state.selectedPackage,
        selectedPackageForm:
          state.selectedPackageForm?.formID === action.payload.docID
            ? {
                ...state.selectedPackageForm,
                locked: action.payload.locked,
              }
            : state.selectedPackageForm,
      };

    case "ADD_SIGNATURE":
      return {
        ...state,
        signatures: [...state.signatures, action.payload],
      };

    default:
      return state;
  }
};

export default userPackagesReducer;
